export const typography = {
  headline: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  body: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  subtitle: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  button: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  overline: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  caption: ['Suisse Intl', 'Helvetica', 'Arial', 'sans-serif'].join(','),
}
